import axiosInstance from './axiosInstance';

export const fetchLocalizaciones = async () => {
  const response = await axiosInstance.get('/localizations');
  return response.data;
};

export const createLocalizacion = async (data) => {
  const response = await axiosInstance.post('/localizations', data);
  return response.data;
};

export const updateLocalizacion = async (id, data) => {
  const response = await axiosInstance.put(`/localizations/${id}`, data);
  return response.data;
};

export const deleteLocalizacion = async (id) => {
  const response = await axiosInstance.delete(`/localizations/${id}`);
  return response.data;
};
